export default __webpack_public_path__ + "static/media/Mark-3-Suit-06.71435308.jpg";